module.exports = __webpack_public_path__ + "static/media/REGULAMENTO-PREMIO-DESTAQUE-ATVOS-2022.b437ee3f.pdf";